export default "__VITE_ASSET__C_5RME0p__"